'use strict';
var LSTouch;

LSTouch = {
  init: function() {
    var lsTouchTimer;
    lsTouchTimer = null;
    return $('body').on('touchend', 'a.lstouch', function(e) {
      var doubleTouch, target, timestamp, touchTicket;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (lsTouchTimer) {
        clearTimeout(lsTouchTimer);
      }
      target = e.currentTarget;
      touchTicket = target.touchTimestamp || 0;
      timestamp = new Date().getTime();
      doubleTouch = (timestamp - touchTicket) < 300;
      if (doubleTouch) {
        window.location = e.currentTarget.href;
        return;
      }
      target.touchTimestamp = timestamp;
      e.type = 'lstouch';
      return lsTouchTimer = setTimeout((function() {
        $(target).trigger('lstouch');
      }), 300);
    });
  }
};

module.exports = LSTouch;

